/* eslint-disable import/prefer-default-export */

export const HIDDEN_CATEGORIES = [
  'Hidden',
  'AgentStatHidden',
];

export const ALLOWED_ON_WORLD = 'World';
